var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9149 11.6599C19.8746 8.13271 16.074 5.9457 12.0001 5.9457C7.92613 5.9457 4.12555 8.13271 2.08525 11.6599C1.97191 11.8666 1.97191 12.12 2.08525 12.3267C4.12555 15.8605 7.92613 18.0542 12.0001 18.0542C16.074 18.0542 19.8746 15.8605 21.9149 12.3267C22.0282 12.12 22.0282 11.8666 21.9149 11.6599ZM12.0001 16.1672C9.69972 16.1672 7.83278 14.3003 7.83278 12C7.83278 9.6996 9.69972 7.83266 12.0001 7.83266C14.3004 7.83266 16.1674 9.6996 16.1674 12C16.1674 14.3003 14.3004 16.1672 12.0001 16.1672Z",
    fill: "#E6F4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.8338C13.5651 14.8338 14.8338 13.565 14.8338 12C14.8338 10.435 13.5651 9.16623 12 9.16623C10.435 9.16623 9.16626 10.435 9.16626 12C9.16626 13.565 10.435 14.8338 12 14.8338Z",
    fill: "#E6F4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.88b98a0ac7571246c4b02526fe0bbd51.svg";
export { ForwardRef as ReactComponent };